import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    padding: 0.5rem 0;

    @media (min-width: 960px){
        cursor: pointer;
    }
`

export const LabelContent = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0.5rem 1rem;

    p{
        color: gray;
        font-size: 1.2rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
    }

    div{
        width: 120%;
        height: 2px;
    }

    ${props => props.isActive && css`
        p{
            color: #7A05A7;
        }

        div{
           background: #7A05A7;
        }
    `}
    
`